import { memo } from 'react'

import type { TZaiSideChatButtonViewProps } from './zai-side-chat-button.types'

const Component: TZaiSideChatButtonViewProps = ({ handleClick, IconComponent }) => (
  <button className="zai-side-chat-button" onClick={handleClick}>
    <IconComponent width="32px" height="32px" color="#FFF" />
  </button>
)

export const ZaiSideChatButtonView = memo(Component)
